export const getLoginFailurePromptBasedOnErrorCode = (errorCode: string) => {
    if (
        errorCode === 'auth/user-not-found' ||
        errorCode === 'auth/invalid-email' ||
        errorCode === 'auth/internal-error' ||
        errorCode === 'auth/wrong-password'
    ) {
        return 'Email and password does not match.'
    }
    return ''
}
